<template>
  <v-row>
    <v-col>
      <CidList />
    </v-col>
  </v-row>
</template>

<script>
  import CidList from "@/components/config/diagnostic_hypothesis/cid/list.vue";

  export default {
    name: "DiagnosticHypothesisCid",
    components: {
      CidList,
    },
  };
</script>

<style lang="sass" scoped></style>
